import { Constants } from '../Constants';

/** Checks if the difference between n1 and n2 is less than Constants.sizeAndPositionTolerance */
export function aboutEqual(n1: number, n2: number) {
  return Math.abs(n1 - n2) < Constants.sizeAndPositionTolerance;
}
